export default "__VITE_ASSET__Df6bBF4L__"